<template>
  <div>
    <emd-alert
      v-if="alert.open"
      :variant="alert.variant"
      :title="alert.msg"
      :noClose="true"
      class="eu-mt_5"
      @cancel="handleAlertModalClose"
    />

    <general-info-card
      class="eu-my_5"
      :data="dataGeneralInfo"
    >
      <template #actions>
        <emd-button
          v-if="showButtonCancelLink"
          color="primary"
          size="small"
          :disabled="loadingCancel"
          @click="handleOpenModal"
        >
          {{ $t('cancelLink') }}
        </emd-button>
      </template>
      <template #modal>
        <confirm-cancel-modal
          :isModalOpen="isModalOpen"
          :isActionDisabled="loadingCancel"
          @confirmClick="handleCancelLink"
          @closeClick="handleCloseModal"
        />
      </template>
    </general-info-card>

    <configuration-card
      class="eu-my_5"
      :data="dataConfiguration"
    />

    <payment-methods-card
      class="eu-my_5"
      :data="dataPaymentMethods"
    />

    <items-card
      class="eu-my_5"
      :data="dataItems"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EmdButton, EmdAlert } from 'emerald-vue/src/components'

import { paymentsLinksCancelEnabled } from '@/actions-permission/payment-links.permissions'

import { isStatusCancelAndExpired } from '../../enums/payment-links-types.enum'
import PaymentsLinksDetailsManager from './payment-links-details.manager.js'

export default {
  name: 'PaymentsLinksInfo',

  components: {
    EmdButton,
    EmdAlert,

    ConfirmCancelModal: () => import('../../components/ConfirmCancelModal'),

    GeneralInfoCard: () => import('./GeneralInfo.vue'),
    ConfigurationCard: () => import('./Configuration.vue'),
    PaymentMethodsCard: () => import('./PaymentMethods.vue'),
    ItemsCard: () => import('./Items.vue')
  },

  data () {
    return {
      isModalOpen: false,
      alert: {
        open: false,
        msg: this.$t('alert-cancel-success'),
        variant: 'success'
      }
    }
  },
  computed: {
    ...mapGetters({
      dataDetail: 'PAYMENTS_LINKS_DETAIL',
      loadingCancel: 'PAYMENT_LINK_CANCEL_LOADING',
      permissionIsEnabled: 'permissionIsEnabled'
    }),

    showButtonCancelLink () {
      return (
        !isStatusCancelAndExpired(this.dataDetail.status) &&
        paymentsLinksCancelEnabled(this.permissionIsEnabled)
      )
    },

    dataGeneralInfo () {
      return new PaymentsLinksDetailsManager(
        this.dataDetail
      ).generalInfoAdapter()
    },
    dataConfiguration () {
      return new PaymentsLinksDetailsManager(
        this.dataDetail
      ).configurationAdapter()
    },
    dataPaymentMethods () {
      return new PaymentsLinksDetailsManager(
        this.dataDetail
      ).paymentMethodsAdapter()
    },
    dataItems () {
      return new PaymentsLinksDetailsManager(this.dataDetail).itemsAdapter()
    }
  },

  methods: {
    ...mapActions(['CANCEL_PAYMENT_LINK', 'GET_PAYMENTS_LINKS_DETAIL']),

    handleOpenModal () {
      this.isModalOpen = true
    },
    handleCloseModal () {
      this.isModalOpen = false
    },
    handleAlertModalClose () {
      this.alert.open = false
    },
    handleCancelLink ({ password }) {
      const params = {
        id: this.$route.params.id,
        body: { password }
      }

      this.CANCEL_PAYMENT_LINK(params)
        .then(() => {
          this.alert.open = true
          this.GET_PAYMENTS_LINKS_DETAIL(this.$route.params.id)
        })
        .catch(({ status }) => {
          if (status === 412) {
            this.alert = {
              open: true,
              variant: 'danger',
              msg: this.$t('general.password-error')
            }
          }
        })
        .finally(() => {
          this.isModalOpen = false
        })
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "cancelLink": "Desativar link",
      "alert-cancel-success": "Link cancelado com sucesso!"
    },
    "en-US": {
      "cancelLink": "Disable Link",
      "alert-cancel-success": "Link canceled successfully!"
    }
  }
</i18n>
